"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _DecoratorsRoot = require("../layout/DecoratorsRoot");

var _locales = require("@meepshop/locales");

var _link = require("@meepshop/link");

var _client = require("@apollo/client");

var _Currency = _interopRequireDefault(require("@meepshop/context/lib/Currency"));

var _menuUtils = require("../utils/menuUtils");

var _generateURL2 = _interopRequireDefault(require("../menu/utils/generateURL"));

var useButtonSettings = function useButtonSettings(page) {
  var _page$pages, _generateURL;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    menuSettings: {}
  },
      menuSettings = _ref.menuSettings;

  var _useContext = (0, _react.useContext)(_DecoratorsRoot.EnhancerContext),
      user = _useContext.user,
      isLogin = _useContext.isLogin;

  var getLanguage = (0, _locales.useGetLanguage)();
  var client = (0, _client.useApolloClient)();

  var _useContext2 = (0, _react.useContext)(_Currency["default"]),
      currency = _useContext2.currency,
      setCurrency = _useContext2.setCurrency;

  var _useTranslation = (0, _locales.useTranslation)(['common', 'menu']),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var router = (0, _link.useRouter)();
  var hasGroup = !menuSettings.expandSubItem && ((_page$pages = page.pages) === null || _page$pages === void 0 ? void 0 : _page$pages.length) > 0;
  var url = (_generateURL = (0, _generateURL2["default"])(page.action, page.params, isLogin)) !== null && _generateURL !== void 0 ? _generateURL : '';
  var id = (0, _menuUtils.getId)({
    locale: i18n.language,
    currency: currency,
    id: page.id,
    action: page.action
  }); // 顯示的標題

  var title = (0, _menuUtils.getTitle)({
    isLogin: isLogin,
    user: user,
    t: t,
    getLanguage: getLanguage,
    id: id,
    action: page.action,
    title: page.title,
    params: page.params
  }); // 是否為 active

  var isActive = (0, _menuUtils.getActive)(url, {
    router: router,
    currency: currency,
    locale: i18n.language,
    id: page.id,
    action: page.action
  }); // 是否有點擊事件

  var action = (0, _menuUtils.getAction)({
    isLogin: isLogin,
    t: t,
    i18n: i18n,
    id: page.id,
    action: page.action,
    setCurrency: setCurrency,
    client: client
  });
  return {
    action: action,
    title: title,
    url: url,
    isActive: isActive,
    hasGroup: hasGroup,
    refTitle: getLanguage(page.title),
    target: page.newWindow ? '_blank' : undefined
  };
};

var _default = useButtonSettings;
exports["default"] = _default;